import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';

const isMobile = window.innerWidth < 960;

const styles = theme => ({
  backdrop: {
    position: 'fixed',
    zIndex: 2,
    top: window.innerHeight + 'px',
    right: 0, // on desktop nav will be on the left
    bottom: 0,
    background: 'linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.9))',
    transition: 'top 0.3s',
    width: isMobile ? '100vw' : '80vw'
  }
});

class ActionSheetBackdrop extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { classes, openStoryId } = this.props;

    // for now this is dedicated to story opens
    let top = openStoryId ? 0 : window.innerHeight + 'px';

    return (
      <div className={classes.backdrop} style={{top: top}} />
    );
  }
}

const mapStateToProps = state => ({
  openStoryId: state.storyReducer.openStoryId
});

export default connect(mapStateToProps, {})(withStyles(styles, {withTheme: true})(ActionSheetBackdrop));
